<template>
  <Icon :component="LockSvg" :style="{ fontSize: '14px' }" />
</template>

<script lang="ts">
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import LockSvg from './svg/LockSvg.vue';

export default defineComponent({
  name: 'LockIcon',
  components: {
    Icon
  },
  data() {
    return {
      LockSvg: markRaw(LockSvg)
    };
  }
});
</script>
